import React from 'react';
import { StyleSheet, View } from 'react-native';

import Avatar from './avatar';
import SpeechBalloon from './speech-balloon';
import { useColors } from '../../../../../../hooks';
import useDevice from '../../../../../../hooks/use-device';
import ThemedText2 from '../../../../../themed-text-2';
import type { DialogInterface } from '../../dialog-activity';

interface SpeechContainerProps {
  dialog: DialogInterface;
  isRightSide?: boolean;
}

export default function SpeechContainer({
  dialog,
  isRightSide = false,
}: SpeechContainerProps) {
  const colors = useColors();
  const { isDesktop } = useDevice();

  return (
    <View style={[styles.container, isRightSide && styles.containerRight]}>
      <View
        style={[
          styles.innerContainer,
          isDesktop && styles.innerContainerMaxWidth,
        ]}
      >
        {!isRightSide && (
          <Avatar
            style={styles.leftAvatar}
            size={isDesktop ? 50 : 40}
            color={colors.primary}
          />
        )}
        <View
          style={[
            styles.balloonContainer,
            isRightSide && styles.balloonContainerRight,
          ]}
        >
          <ThemedText2
            style={styles.speakerName}
            fontSize={14}
            fontWeightStyle="bold"
          >
            {dialog.speaker}
          </ThemedText2>
          <SpeechBalloon
            line={dialog.line}
            isRightSide={isRightSide}
            fontSize={isDesktop ? 18 : 16}
            lineTranslation={dialog.lineTranslation}
          />
        </View>
        {isRightSide && (
          <Avatar
            style={styles.rightAvatar}
            size={isDesktop ? 50 : 40}
            color={colors.oeAppSecondary}
          />
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginVertical: 8,
    alignItems: 'flex-start',
  },
  containerRight: {
    alignItems: 'flex-end',
  },
  innerContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  innerContainerMaxWidth: {
    maxWidth: '80%',
  },
  balloonContainer: {
    alignItems: 'flex-start',
    flex: 1,
  },
  balloonContainerRight: {
    alignItems: 'flex-end',
  },
  speakerName: {
    marginBottom: 4,
  },
  leftAvatar: {
    marginRight: 12,
  },
  rightAvatar: {
    marginLeft: 12,
  },
});
